// for PROD
export const PROD_CONFIGS = {
  backend_port: "", // define the backend port
  backend_url_path: "/api/", // custom backend url path if necessary. default is "/"
  route_basename: "/", // for defining the base route for BrowserRouter
};
